import React from "react";
import { Container } from "components/common";
import { Wrapper, Details } from "./styles";
export const Education = () => {
     return (
    <div>
      <Wrapper as={Container} id='education'>
        <h1><u>Education:</u></h1>
        <Details as={Container} id='edu_bos'>
          <div className='containers'>
             <div className='skill_box'>
              <div className='skill_title'>
                
                <h2>Bachelor of Engineering(B.E) - <i>Computer Engineering.</i><i>2018-2022.</i><br></br><br></br>
                <h3><u>JSPM'S Jaywantrao Sawant College Of Engineering ,Pune.</u><br></br> <br></br><b>CGPA : 8.84.</b></h3></h2>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <hr></hr>
          <div className='skill_box'>
              <div className='skill_title'>
                
                <h2>XII - <i>(H.S.C).</i><i>2017-2018.</i><br></br><br></br>
                <h3><u>B.K. Kawale Madhyamik v Uchha Madhyamik Vidhyalaya Rajaram-nagar,Nashik.</u><br></br> <br></br><b>Secured: 77.35 %.</b></h3></h2>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            
            <hr></hr>
            <div className='skill_box'>
              <div className='skill_title'>
                
                <h2>X - <i>(S.S.C).</i><i>2015-2016.</i><br></br><br></br>
                <h3><u>B.K. Kawale Madhyamik v Uchha Madhyamik Vidhyalaya Rajaram-nagar,Nashik.</u><br></br> <br></br><b>Secured: 87.60 %.</b></h3></h2>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            
          </div>
        </Details>
      </Wrapper>
    </div>
  );
};